import React from 'react';
import { Link } from "react-router-dom";
import '../../Home.css';
import '../../Details.css';

function CE() {
  return (
    <div className = "grid-container">
      <div className="grid-item back">
        <Link to="/Home" className="purple back">Back</Link>
      </div>

      <div className="grid-item exit">
          <a className="purple exit" href = "https://www.sfu.ca/mechatronics.html" target = "_blank" rel="noopener noreferrer">Exit</a>
      </div>

      <div className="hint-place">
          <Link to="/RaWRxD" className="hint">.</Link>
      </div>

      <div className = "ce">
        <div>
          <h1>You can take these complementary electives any time in your degree.</h1>
        </div>

        <div>
          <h1>The navigator is just a recommendation of when to take those electives.</h1>
        </div>

        <div>
          <h1>Here are the full list of approved electives.</h1>
        </div>

        <div>
          <a href = "https://www.sfu.ca/content/dam/sfu/mechatronics/Current%20students/Undergraduate%20students/Pre-approved%20Compl%20Electives%2C%20July%202014-2.pdf" target = "_blank" rel="noopener noreferrer"><h1>Click Me</h1></a>
        </div>
        
      </div>
    </div>
    
  )
}
export default CE;